module.exports = __webpack_public_path__ + "7c26485afea5b11a601b3ad1d49faef2.png";